import { render } from "./BienImmoUpdateModal.vue?vue&type=template&id=346898b6"
import script from "./BienImmoUpdateModal.ts?vue&type=script&lang=js"
export * from "./BienImmoUpdateModal.ts?vue&type=script&lang=js"

import "./BienImmoUpdateModal.vue?vue&type=style&index=0&id=346898b6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__